import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconRedo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.6023 4.33525C11.3826 4.11558 11.3826 3.75942 11.6023 3.53975C11.8219 3.32008 12.1781 3.32008 12.3977 3.53975L15.0227 6.16475C15.1326 6.27459 15.1875 6.41854 15.1875 6.5625C15.1875 6.63877 15.1723 6.71149 15.1448 6.77782C15.1174 6.84416 15.0767 6.90632 15.0227 6.96025L12.3977 9.58525C12.1781 9.80492 11.8219 9.80492 11.6023 9.58525C11.3826 9.36558 11.3826 9.00942 11.6023 8.78975L13.267 7.125H6.75C5.1967 7.125 3.9375 8.3842 3.9375 9.9375C3.9375 11.4908 5.19656 12.75 6.74982 12.75H10.875C11.1857 12.75 11.4375 13.0018 11.4375 13.3125C11.4375 13.6232 11.1857 13.875 10.875 13.875H6.74982C4.57516 13.875 2.8125 12.1121 2.8125 9.9375C2.8125 7.76288 4.57538 6 6.75 6H13.267L11.6023 4.33525Z",
		fill: "#33373D"
	})
});
export { SvgIconRedo as ReactComponent };
